import type { LocationsResponse, OcpiLocation } from "../types/ocpi";

/**
 * OCPI reflects the Origin header and allows browser calls from both
 * localhost (dev) and the deployed domain. The Netlify Function proxy
 * remains available at /api/locations for future use (e.g. an
 * Authorization-token rollout), but is not on the default path.
 * Override with VITE_LOCATIONS_URL at build time.
 */
const LOCATIONS_URL =
  import.meta.env.VITE_LOCATIONS_URL ??
  "https://lumicle.mapcontentpartners.service.electroop.io/2.2/locations";

export async function fetchLocations(signal?: AbortSignal): Promise<OcpiLocation[]> {
  const res = await fetch(LOCATIONS_URL, {
    signal,
    headers: { Accept: "application/json" },
  });
  if (!res.ok) {
    throw new Error(`OCPI /locations failed: ${res.status} ${res.statusText}`);
  }
  const json = (await res.json()) as LocationsResponse | OcpiLocation[];
  const items = Array.isArray(json) ? json : json.data ?? [];
  return items.filter((l) => l && l.coordinates && l.evses);
}
